import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import DayWasteGasReportModal from "./modules/DayWasteGasReportModal.vue";
import { getAction, downloadFile } from '@/api/manage';
import moment from 'moment';
import { querySiteTree, queryUserTreeList } from '@/api/api';
export default {
  name: 'DayWasteGasReportList',
  // mixins: [JeecgListMixin],
  components: {
    DayWasteGasReportModal: DayWasteGasReportModal
  },
  data: function data() {
    return {
      visible: false,
      date: '',
      userTree: [],
      siteTree: [],
      userIds: '',
      siteId: [],
      drawerVisible: false,
      reportObj: {},
      queryDate: [],
      tableArr: [],
      dataSource: [],
      url: '/om/day/waste/gas/report',
      // pagePath: '/om/day/waste/gas/report',
      pageTitle: '烟气日报',
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      // 表头
      columns: [{
        title: '日报时间',
        dataIndex: 'time',
        key: 'time',
        align: 'center'
      }, {
        dataIndex: 'userId_userName',
        key: 'userId_userName',
        title: '数据审核员',
        align: 'center'
      }, {
        dataIndex: 'createTime',
        key: 'createTime',
        title: '创建时间',
        align: 'center'
      }, {
        title: '操作',
        key: 'action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {},
  computed: {},
  mounted: function mounted() {
    this.getOperationList();
    this.getUser();
  },
  watch: {
    userIds: function userIds(value) {
      console.log('value', value);
    },
    siteId: function siteId(value) {
      console.log('value', value);
    },
    drawerVisible: function drawerVisible(value) {
      if (!value) {
        this.reportObj = {};
      }
    },
    visible: function visible(value) {
      if (!value) {
        this.siteId = [];
      }
    }
  },
  methods: {
    // 按钮权限
    getAuth: function getAuth(id) {
      return id == this.$store.getters.userInfo.id;
    },
    onToExport: function onToExport(record) {
      // console.log('record', record)
      downloadFile(record.time + record.userId_userName + '日报.pdf', window.domainURL + '/om/day/waste/gas/report/exportPdf?id=' + record.id, {});
    },
    onToSearch: function onToSearch() {
      this.getOperationList();
    },
    getUser: function getUser() {
      var _this = this;

      // 用户
      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];

            _this.userTree.push(temp);
          }
        }
      });
    },
    onDateChange: function onDateChange(value) {
      var arr = [];
      value.forEach(function (item, index) {
        arr.push(item.format('YYYY-MM-DD'));
      });
      this.queryDate = arr; // console.log('value', arr)
    },
    handleTableChange: function handleTableChange(pagination) {
      // console.log(pagination)
      this.ipagination = pagination;
      this.getOperationList();
    },
    onToEdit: function onToEdit(value) {
      console.log('value', value); // this.getUser()

      value.dayWasteGasReportSites.forEach(function (item, index) {
        if (!item.runSituation) {
          item.runSituation = '正常';
        }

        if (!item.deviceStatus) {
          item.deviceStatus = '所有设备正常';
        }
      });
      this.$refs.moudle.drawerVisible = true;
      this.$refs.moudle.detailState = false;
      this.$refs.moudle.reportObj = value;
      this.$refs.moudle.tableArr = value.dayWasteGasReportSites;
    },
    onToDetail: function onToDetail(value) {
      // console.log('value', value)
      // this.getUser()
      value.dayWasteGasReportSites.forEach(function (item, index) {
        if (!item.runSituation) {
          item.runSituation = '正常';
        }

        if (!item.deviceStatus) {
          item.deviceStatus = '所有设备正常';
        }
      });
      this.$refs.moudle.drawerVisible = true;
      this.$refs.moudle.detailState = true;
      this.$refs.moudle.reportObj = value;
      this.$refs.moudle.tableArr = value.dayWasteGasReportSites;
    },
    handleOk: function handleOk(value) {
      // console.log('value', value)
      this.getGenerate();
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    },
    onToAdd: function onToAdd() {
      this.visible = true;
      this.date = moment(new Date());

      if (window.localStorage.getItem('selectedOprationSiteId')) {
        console.log(window.localStorage.getItem('selectedOprationSiteId'));
        this.siteId = window.localStorage.getItem('selectedOprationSiteId').split(',');
      }

      this.getSite();
    },
    getSite: function getSite() {
      var _this2 = this;

      // 用户
      querySiteTree({
        addrType: 1
      }).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];

            _this2.siteTree.push(temp);
          }
        }
      });
    },
    getOperationList: function getOperationList() {
      var _this3 = this;

      var param = {
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        column: 'time',
        order: 'desc'
      };

      if (this.queryDate.length > 0) {
        param.stime = this.queryDate[0];
        param.etime = this.queryDate[1];
      }

      if (this.userIds) {
        param.userId = this.userIds;
      }

      getAction(this.url, param).then(function (res) {
        if (res.success) {
          _this3.dataSource = res.result.records;
          _this3.ipagination.total = res.result.total;
        }
      });
    },
    getGenerate: function getGenerate() {
      var _this4 = this;

      var params = {};
      params.stime = this.date.format('YYYY-MM-DD');

      if (this.siteId.length > 0) {
        window.localStorage.setItem('selectedOprationSiteId', this.siteId);
        params.siteIds = this.siteId.join(',');
        this.visible = false;
      } else {
        this.$message.warning('请选择站点');
      } // debugger


      getAction('/om/day/waste/gas/report/generate', params).then(function (res) {
        if (res.success) {
          // debugger
          _this4.tableArr = res.result.dayWasteGasReportSites;

          _this4.onToEdit(res.result);
        }
      });
    }
  }
};